var _filter, _filter2, _g, _g2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoPlaceholder = function SvgLogoPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 50"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffa3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00d4aa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00a693",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00ffa3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00d4aa",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00d4aa",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#00b7b7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#009db3",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#000",
    floodOpacity: 0.2
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 2 10 32 5-10 5 10L30 2h-6l-9 22L6 2Z",
    fill: "url(#a)",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 24,
    r: 1.8,
    fill: "#fff",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 2 4 10 5 12 5-12 4-10",
    fill: "none",
    stroke: "#fff",
    opacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Inter', 'Segoe UI', 'Roboto', Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("text", {
    y: 20,
    fill: "url(#c)",
    filter: "url(#d)",
    transform: "translate(48 15)"
  }, "Viet"), /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 20,
    fill: "url(#e)",
    filter: "url(#d)",
    letterSpacing: 1,
    transform: "translate(48 15)"
  }, "Scan"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 2,
    fill: "url(#e)",
    opacity: 0.4,
    rx: 1,
    transform: "translate(48 38)"
  })));
};
export default SvgLogoPlaceholder;